import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
/**
 * Copyright 2022 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import { classNames, responsiveClassNames } from "../../utils/helpers";
import s from './Hidden.module.css';
export const Hidden = ({ as: TagName = 'div', children, visibility, hide, inline }) => {
    const rootClassNames = classNames(s.root, ...responsiveClassNames(s, '--hidden', hide), visibility && s['--visibility'], inline && s['--inline']);
    if (typeof children === 'function')
        return _jsx(_Fragment, { children: children(rootClassNames) });
    return (_jsx(TagName, { "data-testid": "st-hidden", className: rootClassNames, children: children }));
};
